import { useState, useCallback } from 'react'

const useCelebration = () => {
  const [celebrationTrigger, setCelebrationTrigger] = useState(0)
  const [celebrationType, setCelebrationType] = useState('task_complete')
  const [celebrationCharacter, setCelebrationCharacter] = useState('👦')
  const [celebrationMessage, setCelebrationMessage] = useState('')
  const [celebrationPoints, setCelebrationPoints] = useState(null) // New state for points

  const triggerCelebration = useCallback(({
    type = 'task_complete',
    character = '👦',
    message = '',
    pointsEarned = null // New parameter for actual points
  }) => {
    setCelebrationType(type)
    setCelebrationCharacter(character)
    setCelebrationMessage(message)
    setCelebrationPoints(pointsEarned) // Set the actual points earned
    setCelebrationTrigger(prev => prev + 1)
  }, [])

  const celebrateTaskComplete = useCallback((childAvatar = '👦', taskTitle = '', pointsEarned = null) => {
    triggerCelebration({
      type: 'task_complete',
      character: childAvatar,
      message: taskTitle ? `Great job on "${taskTitle}"! 🌟` : '',
      pointsEarned: pointsEarned // Pass the actual points
    })
  }, [triggerCelebration])

  const celebrateLevelUp = useCallback((childAvatar = '👦', newLevel = 1) => {
    triggerCelebration({
      type: 'level_up',
      character: childAvatar,
      message: `Level ${newLevel} achieved! 🚀`
    })
  }, [triggerCelebration])

  const celebrateRewardEarned = useCallback((childAvatar = '👦', rewardTitle = '') => {
    triggerCelebration({
      type: 'reward_earned',
      character: childAvatar,
      message: rewardTitle ? `You earned "${rewardTitle}"! 🎁` : ''
    })
  }, [triggerCelebration])

  const celebrateStreak = useCallback((childAvatar = '👦', streakDays = 1) => {
    triggerCelebration({
      type: 'streak',
      character: childAvatar,
      message: `${streakDays} day streak! 🔥`
    })
  }, [triggerCelebration])

  return {
    celebrationTrigger,
    celebrationType,
    celebrationCharacter,
    celebrationMessage,
    celebrationPoints, // Return the points state
    celebrateTaskComplete,
    celebrateLevelUp,
    celebrateRewardEarned,
    celebrateStreak,
    triggerCelebration
  }
}

export default useCelebration